module.exports = __webpack_public_path__ + "img/productView3.8eb1ff59.png";